import { gql } from '@apollo/client';
import { MembershipInputV3 } from './createUserV3.queries';

interface UserBasicDetail {
  id: string;
  email?: string;
  name: string;
  firstName: string;
  lastName: string;
  password?: string;
}

// ---------------- Members Page: Update Member -------

export interface UpdateUserInputV3 extends UserBasicDetail {
  memberships: MembershipInputV3[];
}

export interface UpdateUserV3Response {
  updateUserV3: {
    name: string;
  };
}

export const UPDATE_USER_V3 = gql`
  mutation updateUserV3($input: UpdateUserInputV3!) {
    updateUserV3(input: $input) {
      name
    }
  }
`;

// ---------------- Organisation Page: Update Member -------

export interface UpdateUserInputV3ForOrg extends UserBasicDetail {
  membership: MembershipInputV3;
}

export interface UpdateUserV3ForOrgResponse {
  updateUserV3ForOrganisation: {
    name: string;
  };
}

export const UPDATE_USER_V3_FOR_ORGANISATION = gql`
  mutation updateUserV3ForOrganisation(
    $input: UpdateUserInputV3ForOrganisation!
  ) {
    updateUserV3ForOrganisation(input: $input) {
      name
    }
  }
`;
